import Q from 'q';
import _ from 'underscore';
import get_first_left_child_entity_by_tree_entity_list
    from 'nllib/src/tree-helper/get_first_left_child_entity_by_tree_entity_list';
import get_user_info from 'yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_user_info'
import get_menu_data from 'yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_menu_data'
import aRouter from '@/router'

const redirect_to_user_back_home = function (pParameter) {
    if (!pParameter) pParameter = {};
    const clear_cache_get_user_info = pParameter.clear_cache_get_user_info;

    return Q.when()
        .then(function () {
            const list = [];
            list.push(get_user_info({
                clear_cache: clear_cache_get_user_info,
            }));
            list.push(get_menu_data({
                clear_cache: clear_cache_get_user_info,
            }));
            return Q.all(list);
        })
        .spread(function (data_get_user_info, data_get_menu_data) {
            const menu_list = data_get_menu_data.menu_list;

            const __get_first_left_child = function (first_item) {
                if (!first_item) {
                    const msg = `__get_first_left_child parameter error, code=001`;
                    console.error(msg);
                    console.trace();
                    return;
                }

                if (!first_item.sub_list) {
                    return first_item;
                }

                if (first_item.sub_list.length <= 0) {
                    return first_item;
                }

                const next_first_item = first_item.sub_list[0];
                return __get_first_left_child(next_first_item);
            };
            const get_first_left_child = function (list) {
                if (!_.isArray(list)) {
                    const msg = `get_first_left_child parameter error, code=001`;
                    console.error(msg);
                    console.trace();
                    return;
                }

                if (list.length <= 0) {
                    return;
                }

                const first_item = list[0];
                return __get_first_left_child(first_item);

            };

            // const menu = get_first_left_child(menu_list);
            const menu = get_first_left_child_entity_by_tree_entity_list({
                tree_entity_list: menu_list,
                property_name_sub_entity_list: `sub_list`,
            });

            if (!menu) {
                const msg = `redirect_to_user_back_home parameter error, code=001`;
                console.error(msg);
                console.trace();
                alert(`对不起，您没有此权限！code=001`);
                return Q.reject({msg: msg});
            }

            const route_name = menu.routeName;
            if (!route_name) {
                const msg = `redirect_to_user_back_home parameter error, code=002`;
                console.error(msg);
                console.trace();
                alert(`对不起，您没有此权限！code=002`);
                return Q.reject({msg: msg});
            }

            aRouter.push({
                name: route_name,
            });
        })
        .catch(function (ex) {
            console.error(ex);
            console.trace();
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;
};

export default redirect_to_user_back_home;
